import { Injectable } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { DialogRef } from '@angular/cdk/dialog';
import { RestorativeExportModal, RestorativeExportModalData } from './restorativeExport.component';
import { ExportRequest } from '../orthoCadExport/orthoCadExport.service';

@Injectable({ providedIn: 'root' })
export class RestorativeExportService {
	constructor(private readonly modalWindowService: TlkModalWindowService) {}

	openRestorativeExportModal(caseTypeId: string, request: ExportRequest): DialogRef<void, unknown> {
		const data: RestorativeExportModalData = {
			caseTypeId: +caseTypeId,
			orderId: request.orderId,
			orderDetailsId: request.orderDetailsId,
		};

		return this.modalWindowService.open<void>(RestorativeExportModal, {
			width: '480px',
			disableClose: true,
			data,
		});
	}
}
